var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKanBanBoardSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37503 1.78814e-07H11.125C11.6075 1.78814e-07 12 0.392487 12 0.87497V3.12497C12 3.60754 11.6075 4.00003 11.125 4.00003H7.37503C6.89246 4.00003 6.49997 3.60754 6.49997 3.12497V0.87497C6.49997 0.392487 6.89246 1.78814e-07 7.37503 1.78814e-07Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37503 4.99997H11.125C11.6075 4.99997 12 5.39246 12 5.87503V11.125C12 11.6075 11.6075 12 11.125 12H7.37503C6.89246 12 6.49997 11.6075 6.49997 11.125V5.87503C6.49997 5.39246 6.89246 4.99997 7.37503 4.99997Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.874969 7.99997H4.62497C5.10754 7.99997 5.50003 8.39246 5.50003 8.87503V11.125C5.50003 11.6075 5.10754 12 4.62497 12H0.874969C0.392487 12 0 11.6075 0 11.125V8.87503C0 8.39246 0.392487 7.99997 0.874969 7.99997Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.874969 0H4.62497C5.10754 0 5.50003 0.392487 5.50003 0.874969V6.12497C5.50003 6.60754 5.10754 7.00003 4.62497 7.00003H0.874969C0.392487 7.00003 0 6.60754 0 6.12497V0.874969C0 0.392487 0.392487 0 0.874969 0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanBanBoardSvg);
export default __webpack_public_path__ + "static/media/KanBanBoardSvg.d52529f1175430afd2ba04c74d38d3fa.svg";
export { ForwardRef as ReactComponent };